import React from "react";
import cx from "classnames";
import { Formik } from "formik";
import * as Yup from "yup";

import { Row, Col, Container } from "reactstrap";
import styles from "./Footer.module.scss";
import axios from "axios";

const newsletter = window._edo_settings.newsletter || {
  title: "Subscribe to our monthly newsletter",
  thank_you_message: "Thanks for subscribing!",
};

const emailSchema = Yup.object().shape({
  firstName: Yup.string().required("Please enter first name"),
  lastName: Yup.string().required("Please enter last name"),
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const FooterSubscribe = () => {
  const handleEmailSubmit = (values, formik) => {
    const formID = "25";
    const formData = {
      input_1: values.email,
      input_2: values.firstName,
      input_3: values.lastName,
      input_12: 'Web',
      input_9: '1',
      input_10: '1',
      input_11: '1',
    };

    axios
      .post(`/wp-json/gf/v2/forms/${formID}/submissions`, formData)
      .then(() => formik.setStatus("success"))
      .catch(() => formik.setStatus("error"))
      .finally(() => formik.setSubmitting(false));
  };

  return (
    <Row className={`${styles.primarySection}`}>
      <Container>
        <Formik
          initialValues={{ email: "", firstName: "", lastName: "" }}
          validationSchema={emailSchema}
          validateOnChange={false}
          onSubmit={handleEmailSubmit}
        >
          {({ values, errors, handleSubmit, handleChange, isSubmitting, status }) => (
            <Row>
              <Col className={`${styles.colSubscribe} text-center justify-content-end`}>
                <Row>
                  <Col xs="12" md="6">
                    <h2 className={`${styles.titleSubscribe} h2 text-md-left`}>{newsletter.title}</h2>
                  </Col>
                  <Col xs="12" md="6" className={styles.colFormSubscribe}>
                    <form onSubmit={handleSubmit} className={styles.inputContainer}>
                      {status !== "success" ? (
                        <div>
                          <div className={styles.inputGroup}>
                            <input
                              className={cx(
                                styles.subscribeDoubleInput,
                                errors.firstName ? styles.subscribeInputError : null
                              )}
                              type="text"
                              name="firstName"
                              placeholder="First name"
                              onChange={handleChange}
                              value={values.firstName}
                            />
                            <input
                              className={cx(
                                styles.subscribeDoubleInput,
                                errors.lastName ? styles.subscribeInputError : null
                              )}
                              type="text"
                              name="lastName"
                              placeholder="Last name"
                              onChange={handleChange}
                              value={values.lastName}
                            />
                          </div>
                          <div className={styles.inputGroup}>
                            <input
                              className={cx(
                                styles.subscribeInput,
                                errors.email ? styles.subscribeInputError : null
                              )}
                              type="email"
                              name="email"
                              placeholder="Email address"
                              onChange={handleChange}
                              value={values.email}
                            />
                            <button className={styles.subscribeButton}>Subscribe</button>
                          </div>
                          <div className={styles.subscribeMessageContainer}>
                            <p className={styles.subscribeMessage}>
                              {Object.keys(errors).length > 0 && Object.values(errors).join(", ")}
                              {status === "error" && !errors.email && "Server error"}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <p>{newsletter.thank_you_message}</p>
                      )}
                    </form>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Formik>
      </Container>
    </Row>
  );
};

export default FooterSubscribe;
